import { useEffect } from 'react';
import { Link, NavLink, Outlet } from 'react-router';
import { applyAccent, applyHeader } from '../lib/branding.ts';
import { appOrigin } from '../lib/hosts.ts';
import { CONTACT_EMAIL } from './site.ts';
import './site.css';

/**
 * 서비스 사이트 레이아웃 (CR-031 → CR-041 제품 페이지 문법): 검정 44px 슬림 상단 바(스크롤 고정) + 본문 + 연회색 푸터.
 * 앱과는 다른 라우터라 "로그인" 은 전체 페이지 이동(앱 호스트). 테넌트 브랜딩은 적용하지 않는다(로그인 화면이 남긴 색을 되돌린다).
 */
export function SiteLayout() {
  useEffect(() => { applyAccent(null); applyHeader(null); }, []);
  return (
    <div className="s-root min-h-screen flex flex-col">
      <header className="s-gnav">
        <div className="s-wrap">
          <Link to="/" className="s-brand" aria-label="PRISM 홈">PRISM</Link>
          <nav className="flex items-center gap-6"><NavLink to="/about">소개</NavLink><NavLink to="/notices">공지사항</NavLink></nav>
          <a href={`${appOrigin()}/login`} className="s-cta">로그인</a>
        </div>
      </header>
      <main className="flex-1"><Outlet /></main>
      <footer className="s-footer">
        <div className="s-wrap">
          <span>PRISM 개인정보 및 정보보안관리체계</span>
          <span>문의 <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> · © 2026 PRISM</span>
        </div>
      </footer>
    </div>
  );
}
